import { render } from "./FormulasIngredientUniversalTrait.vue?vue&type=template&id=54cd04ea"
import script from "./FormulasIngredientUniversalTrait.vue?vue&type=script&lang=js"
export * from "./FormulasIngredientUniversalTrait.vue?vue&type=script&lang=js"

import "./FormulasIngredientUniversalTrait.vue?vue&type=style&index=0&id=54cd04ea&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__